export default "__VITE_ASSET__Dn1EUYeg__"